import { Button, Row } from 'antd'
import ActivityForm from '../../../../../../components/Corporate/Analytics/Reports/ReportsComponents/Activity/ActivityForm'
import ActivityList from '../../../../../../components/Corporate/Analytics/Reports/ReportsComponents/Activity/ActivityList'
import CustomTable from '../../../../../../elements/Table/CustomTable'
import _ from 'lodash'
import React from 'react'

function ActivityDisplay(props) {
  const { formRef, submitting, submit, data, onClickNum } = props
  const columns = [
    {
      Header: 'Collection',
      accessor: 'collection',
      Cell: ({ value }) => _.toUpper(value),
    },
    {
      Header: 'Employee ID',
      accessor: '_id',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Employee',
      accessor: 'fn',
      Cell: ({ original }) => `[${original.code}] ${original.fn}`,
      style: { paddingLeft: 20, alignment: 'left' },
    },
    {
      Header: 'Status',
      accessor: 'status',
      Cell: ({ value }) => _.upperFirst(value),
    },
    {
      Header: 'Count',
      accessor: 'report.count',
      Cell: ({ value, original }) => {
        const readyData = original.report.data
        const { collection, status, fn } = original
        const title = `[${_.toUpper(collection)} - ${_.upperFirst(status)}] ${fn}`
        return <a onClick={() => onClickNum(null, title, readyData)}>{value}</a>
      },
    },
  ]

  return (
    <>
      <ActivityList {...props} />
      <Row>
        <ActivityForm ref={formRef} {...props} />
        <Button style={{ width: '100px' }} type="primary" loading={submitting} onClick={submit}>
          Submit
        </Button>
      </Row>
      <Row style={{ marginTop: 30 }}>
        <CustomTable
          data={data}
          defaultPageSize={20}
          isFilterable={true}
          show={{ csv: { fileName: `Activity-Report` } }}
          fetching={submitting}
          columns={columns}
          defaultSorted={[{ id: 'collection' }, { id: 'fn' }]}
        />
      </Row>
    </>
  )
}

export default ActivityDisplay
